import { render, staticRenderFns } from "./CollectLoans.vue?vue&type=template&id=7a7953ef&scoped=true&"
import script from "./CollectLoans.vue?vue&type=script&lang=js&"
export * from "./CollectLoans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7953ef",
  null
  
)

export default component.exports